import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  EXTERNAL_HOME_ROUTE,
  isExternalAllowedPath,
  useIsExternalUser,
} from '../../helpers/useIsExternalUser';

/**
 * Client-side guard that keeps external (Microsoft) users within their reduced
 * portal. If such a user navigates (or deep-links) to a route outside the
 * allowed set, they are redirected to the Vibe Coded Apps page.
 *
 * This is a display-level reduction, not a backend security boundary. It is
 * implemented as a sibling component (rather than wrapping routes) so it does
 * not interfere with Backstage's routable-extension discovery in FlatRoutes.
 */
export const ExternalUserRouteGuard = () => {
  const { loading, isExternal } = useIsExternalUser();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading || !isExternal) {
      return;
    }
    if (!isExternalAllowedPath(location.pathname)) {
      navigate(EXTERNAL_HOME_ROUTE, { replace: true });
    }
  }, [loading, isExternal, location.pathname, navigate]);

  return null;
};
